import axios from 'axios';

export const downloadSecureFile = async (fileName, user) => {
  try {
    const api = process.env.REACT_APP_API_URL;
    
    if (!user?.token) {
      alert("Você precisa estar logado para acessar este arquivo.");
      return;
    }

    const response = await axios.get(
      `${api}/api/getFiles?file=${fileName}`,
      { headers: { Authorization: `Bearer ${user.token}` } }
    );

    const pdfUrl = response.data.url;
    
    // Detecta Safari (incluindo mobile)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    if (isSafari || isIOS) {
      // Para Safari/iOS: tenta primeiro window.open, se falhar usa link
      try {
        const newWindow = window.open(pdfUrl, '_blank', 'noopener,noreferrer');
        if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
          // Se window.open foi bloqueado, usa método do link
          const link = document.createElement('a');
          link.href = pdfUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.style.display = 'none';
          
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
          }, 100);
        }
      } catch (error) {
        // Fallback: usa método do link
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      // Para outros browsers
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    }
  } catch (error) {
    console.error("Erro ao buscar PDF:", error);
    alert("Você não tem permissão ou houve erro no acesso.");
  }
};
